"use strict";

exports.__esModule = true;
exports.TIME_SERIES_SHIFT = exports.TIME_SERIES_PROCESS = exports.TIME_SERIES_OPERATOR = exports.TIME_SERIES_KIND = exports.TIME_SERIES_INSTANCE = exports.TIME_SERIES_CONDITION = exports.TIME_SERIES_CLASSIFICATION = void 0;
exports.getTimelineDefinition = getTimelineDefinition;
exports.timelineDefinitions = void 0;
var _TextValue = require("../Measures/TextValue/TextValue");
var _ClassificationTimelineValue = require("./TimelineValue/ClassificationTimelineValue");
var _ShiftTimelineValue = require("./TimelineValue/ShiftTimelineValue");
var TIME_SERIES_CONDITION = exports.TIME_SERIES_CONDITION = "condition";
var TIME_SERIES_OPERATOR = exports.TIME_SERIES_OPERATOR = "time-series-operator";
var TIME_SERIES_SHIFT = exports.TIME_SERIES_SHIFT = "time-series-shift";
var TIME_SERIES_CLASSIFICATION = exports.TIME_SERIES_CLASSIFICATION = "time-series-classification";
var TIME_SERIES_PROCESS = exports.TIME_SERIES_PROCESS = "time-series-process";
var TIME_SERIES_KIND = exports.TIME_SERIES_KIND = "time-series-kind";
var TIME_SERIES_INSTANCE = exports.TIME_SERIES_INSTANCE = "time-series-part-instance";
var timelineDefinitions = exports.timelineDefinitions = [{
  name: TIME_SERIES_CONDITION,
  label: "Condition",
  description: ""
}, {
  name: TIME_SERIES_OPERATOR,
  label: "Operator",
  description: "",
  subscriptionProps: {
    element: _TextValue.TextValue,
    responseKey: ["value", "operator"]
  }
}, {
  name: TIME_SERIES_SHIFT,
  label: "Shift",
  description: "",
  subscriptionProps: {
    element: _ShiftTimelineValue.ShiftTimelineValue,
    responseKey: []
  }
}, {
  name: TIME_SERIES_CLASSIFICATION,
  label: "Classification",
  description: "",
  subscriptionProps: {
    element: _ClassificationTimelineValue.ClassificationTimelineValue,
    responseKey: []
  }
}, {
  name: TIME_SERIES_PROCESS,
  label: "Process",
  description: "",
  subscriptionProps: {
    element: _TextValue.TextValue,
    responseKey: ["value", "part_process"]
  }
}, {
  name: TIME_SERIES_KIND,
  label: "Part Kind",
  description: "",
  subscriptionProps: {
    element: _TextValue.TextValue,
    responseKey: ["value", "part_kind"]
  }
}, {
  name: TIME_SERIES_INSTANCE,
  label: "Part Instance",
  description: "",
  subscriptionProps: {
    element: _TextValue.TextValue,
    responseKey: ["value", "part_instance"]
  }
}];

/**
 * Get the definition for the timeline with the given name.
 */
function getTimelineDefinition(name) {
  for (var i = 0; i < timelineDefinitions.length; i++) {
    var definition = timelineDefinitions[i];
    if (definition.name === name) {
      return definition;
    }
  }
  throw new Error("Unknown timeline: " + name);
}